/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UmoRouteImport } from './routes/umo'
import { Route as GrapesPreviewRouteImport } from './routes/grapes-preview'
import { Route as GrapesRouteImport } from './routes/grapes'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthAuthViewRouteImport } from './routes/auth/$authView'
import { Route as AppSubscriptionRouteImport } from './routes/_app/subscription'
import { Route as AppPricingRouteImport } from './routes/_app/pricing'
import { Route as AppOrganizationRouteRouteImport } from './routes/_app/organization/route'
import { Route as AppSchemaBuilderIndexRouteImport } from './routes/_app/schema-builder/index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppOrganizationIndexRouteImport } from './routes/_app/organization/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppStripeSuccessRouteImport } from './routes/_app/stripe/success'
import { Route as AppOrganizationSettingsRouteImport } from './routes/_app/organization/settings'
import { Route as AppOrganizationMembersRouteImport } from './routes/_app/organization/members'
import { Route as AppOrganizationBillingRouteImport } from './routes/_app/organization/billing'
import { Route as AppOrganizationApiKeysRouteImport } from './routes/_app/organization/api-keys'
import { Route as AppCliProjectSelectSessionIdRouteImport } from './routes/_app/cli-project-select/$sessionId'
import { Route as AppAccountAccountViewRouteImport } from './routes/_app/account/$accountView'
import { Route as AppCliAuthSessionIdIndexRouteImport } from './routes/_app/cli-auth/$sessionId/index'
import { Route as AppProjectsProjectSlugLayoutRouteRouteImport } from './routes/_app/projects/$projectSlug/_layout/route'
import { Route as AppProjectsProjectSlugTemplatesIndexRouteImport } from './routes/_app/projects/$projectSlug/templates/index'
import { Route as AppProjectsProjectSlugLayoutIndexRouteImport } from './routes/_app/projects/$projectSlug/_layout/index'
import { Route as AppProjectsProjectSlugLayoutSettingsRouteImport } from './routes/_app/projects/$projectSlug/_layout/settings'
import { Route as AppCliAuthSessionIdCompleteOrganizationSlugRouteImport } from './routes/_app/cli-auth/$sessionId/complete/$organizationSlug'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/index'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/logs'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/edit'

const AppProjectsProjectSlugRouteImport = createFileRoute(
  '/_app/projects/$projectSlug',
)()

const UmoRoute = UmoRouteImport.update({
  id: '/umo',
  path: '/umo',
  getParentRoute: () => rootRouteImport,
} as any)
const GrapesPreviewRoute = GrapesPreviewRouteImport.update({
  id: '/grapes-preview',
  path: '/grapes-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const GrapesRoute = GrapesRouteImport.update({
  id: '/grapes',
  path: '/grapes',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthAuthViewRoute = AuthAuthViewRouteImport.update({
  id: '/auth/$authView',
  path: '/auth/$authView',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSubscriptionRoute = AppSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPricingRoute = AppPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationRouteRoute = AppOrganizationRouteRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectsProjectSlugRoute = AppProjectsProjectSlugRouteImport.update({
  id: '/projects/$projectSlug',
  path: '/projects/$projectSlug',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSchemaBuilderIndexRoute = AppSchemaBuilderIndexRouteImport.update({
  id: '/schema-builder/',
  path: '/schema-builder/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationIndexRoute = AppOrganizationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStripeSuccessRoute = AppStripeSuccessRouteImport.update({
  id: '/stripe/success',
  path: '/stripe/success',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationSettingsRoute = AppOrganizationSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationMembersRoute = AppOrganizationMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationBillingRoute = AppOrganizationBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationApiKeysRoute = AppOrganizationApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppCliProjectSelectSessionIdRoute =
  AppCliProjectSelectSessionIdRouteImport.update({
    id: '/cli-project-select/$sessionId',
    path: '/cli-project-select/$sessionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountAccountViewRoute = AppAccountAccountViewRouteImport.update({
  id: '/account/$accountView',
  path: '/account/$accountView',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCliAuthSessionIdIndexRoute =
  AppCliAuthSessionIdIndexRouteImport.update({
    id: '/cli-auth/$sessionId/',
    path: '/cli-auth/$sessionId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutRouteRoute =
  AppProjectsProjectSlugLayoutRouteRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugTemplatesIndexRoute =
  AppProjectsProjectSlugTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugLayoutIndexRoute =
  AppProjectsProjectSlugLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutSettingsRoute =
  AppProjectsProjectSlugLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppCliAuthSessionIdCompleteOrganizationSlugRoute =
  AppCliAuthSessionIdCompleteOrganizationSlugRouteImport.update({
    id: '/cli-auth/$sessionId/complete/$organizationSlug',
    path: '/cli-auth/$sessionId/complete/$organizationSlug',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport.update({
    id: '/templates/$templateSlug/',
    path: '/templates/$templateSlug/',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport.update({
    id: '/templates/$templateSlug/logs',
    path: '/templates/$templateSlug/logs',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugEditRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport.update({
    id: '/templates/$templateSlug/edit',
    path: '/templates/$templateSlug/edit',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/dashboard': typeof DashboardRoute
  '/grapes': typeof GrapesRoute
  '/grapes-preview': typeof GrapesPreviewRoute
  '/umo': typeof UmoRoute
  '/organization': typeof AppOrganizationRouteRouteWithChildren
  '/pricing': typeof AppPricingRoute
  '/subscription': typeof AppSubscriptionRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/': typeof AppIndexRoute
  '/account/$accountView': typeof AppAccountAccountViewRoute
  '/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/organization/billing': typeof AppOrganizationBillingRoute
  '/organization/members': typeof AppOrganizationMembersRoute
  '/organization/settings': typeof AppOrganizationSettingsRoute
  '/stripe/success': typeof AppStripeSuccessRoute
  '/account': typeof AppAccountIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/organization/': typeof AppOrganizationIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/schema-builder': typeof AppSchemaBuilderIndexRoute
  '/projects/$projectSlug': typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  '/cli-auth/$sessionId': typeof AppCliAuthSessionIdIndexRoute
  '/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/projects/$projectSlug/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/projects/$projectSlug/': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/projects/$projectSlug/templates': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/projects/$projectSlug/templates/$templateSlug': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRoutesByTo {
  '/dashboard': typeof DashboardRoute
  '/grapes': typeof GrapesRoute
  '/grapes-preview': typeof GrapesPreviewRoute
  '/umo': typeof UmoRoute
  '/pricing': typeof AppPricingRoute
  '/subscription': typeof AppSubscriptionRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/': typeof AppIndexRoute
  '/account/$accountView': typeof AppAccountAccountViewRoute
  '/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/organization/billing': typeof AppOrganizationBillingRoute
  '/organization/members': typeof AppOrganizationMembersRoute
  '/organization/settings': typeof AppOrganizationSettingsRoute
  '/stripe/success': typeof AppStripeSuccessRoute
  '/account': typeof AppAccountIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/organization': typeof AppOrganizationIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/schema-builder': typeof AppSchemaBuilderIndexRoute
  '/projects/$projectSlug': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/cli-auth/$sessionId': typeof AppCliAuthSessionIdIndexRoute
  '/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/projects/$projectSlug/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/projects/$projectSlug/templates': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/projects/$projectSlug/templates/$templateSlug': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/grapes': typeof GrapesRoute
  '/grapes-preview': typeof GrapesPreviewRoute
  '/umo': typeof UmoRoute
  '/_app/organization': typeof AppOrganizationRouteRouteWithChildren
  '/_app/pricing': typeof AppPricingRoute
  '/_app/subscription': typeof AppSubscriptionRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/$accountView': typeof AppAccountAccountViewRoute
  '/_app/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/_app/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/_app/organization/billing': typeof AppOrganizationBillingRoute
  '/_app/organization/members': typeof AppOrganizationMembersRoute
  '/_app/organization/settings': typeof AppOrganizationSettingsRoute
  '/_app/stripe/success': typeof AppStripeSuccessRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/organization/': typeof AppOrganizationIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/schema-builder/': typeof AppSchemaBuilderIndexRoute
  '/_app/projects/$projectSlug': typeof AppProjectsProjectSlugRouteWithChildren
  '/_app/projects/$projectSlug/_layout': typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  '/_app/cli-auth/$sessionId/': typeof AppCliAuthSessionIdIndexRoute
  '/_app/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/_app/projects/$projectSlug/_layout/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/_app/projects/$projectSlug/_layout/': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/_app/projects/$projectSlug/templates/': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/grapes'
    | '/grapes-preview'
    | '/umo'
    | '/organization'
    | '/pricing'
    | '/subscription'
    | '/auth/$authView'
    | '/'
    | '/account/$accountView'
    | '/cli-project-select/$sessionId'
    | '/organization/api-keys'
    | '/organization/billing'
    | '/organization/members'
    | '/organization/settings'
    | '/stripe/success'
    | '/account'
    | '/admin'
    | '/organization/'
    | '/projects'
    | '/schema-builder'
    | '/projects/$projectSlug'
    | '/cli-auth/$sessionId'
    | '/cli-auth/$sessionId/complete/$organizationSlug'
    | '/projects/$projectSlug/settings'
    | '/projects/$projectSlug/'
    | '/projects/$projectSlug/templates'
    | '/projects/$projectSlug/templates/$templateSlug/edit'
    | '/projects/$projectSlug/templates/$templateSlug/logs'
    | '/projects/$projectSlug/templates/$templateSlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/dashboard'
    | '/grapes'
    | '/grapes-preview'
    | '/umo'
    | '/pricing'
    | '/subscription'
    | '/auth/$authView'
    | '/'
    | '/account/$accountView'
    | '/cli-project-select/$sessionId'
    | '/organization/api-keys'
    | '/organization/billing'
    | '/organization/members'
    | '/organization/settings'
    | '/stripe/success'
    | '/account'
    | '/admin'
    | '/organization'
    | '/projects'
    | '/schema-builder'
    | '/projects/$projectSlug'
    | '/cli-auth/$sessionId'
    | '/cli-auth/$sessionId/complete/$organizationSlug'
    | '/projects/$projectSlug/settings'
    | '/projects/$projectSlug/templates'
    | '/projects/$projectSlug/templates/$templateSlug/edit'
    | '/projects/$projectSlug/templates/$templateSlug/logs'
    | '/projects/$projectSlug/templates/$templateSlug'
  id:
    | '__root__'
    | '/_app'
    | '/dashboard'
    | '/grapes'
    | '/grapes-preview'
    | '/umo'
    | '/_app/organization'
    | '/_app/pricing'
    | '/_app/subscription'
    | '/auth/$authView'
    | '/_app/'
    | '/_app/account/$accountView'
    | '/_app/cli-project-select/$sessionId'
    | '/_app/organization/api-keys'
    | '/_app/organization/billing'
    | '/_app/organization/members'
    | '/_app/organization/settings'
    | '/_app/stripe/success'
    | '/_app/account/'
    | '/_app/admin/'
    | '/_app/organization/'
    | '/_app/projects/'
    | '/_app/schema-builder/'
    | '/_app/projects/$projectSlug'
    | '/_app/projects/$projectSlug/_layout'
    | '/_app/cli-auth/$sessionId/'
    | '/_app/cli-auth/$sessionId/complete/$organizationSlug'
    | '/_app/projects/$projectSlug/_layout/settings'
    | '/_app/projects/$projectSlug/_layout/'
    | '/_app/projects/$projectSlug/templates/'
    | '/_app/projects/$projectSlug/templates/$templateSlug/edit'
    | '/_app/projects/$projectSlug/templates/$templateSlug/logs'
    | '/_app/projects/$projectSlug/templates/$templateSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  GrapesRoute: typeof GrapesRoute
  GrapesPreviewRoute: typeof GrapesPreviewRoute
  UmoRoute: typeof UmoRoute
  AuthAuthViewRoute: typeof AuthAuthViewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/umo': {
      id: '/umo'
      path: '/umo'
      fullPath: '/umo'
      preLoaderRoute: typeof UmoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grapes-preview': {
      id: '/grapes-preview'
      path: '/grapes-preview'
      fullPath: '/grapes-preview'
      preLoaderRoute: typeof GrapesPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grapes': {
      id: '/grapes'
      path: '/grapes'
      fullPath: '/grapes'
      preLoaderRoute: typeof GrapesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/$authView': {
      id: '/auth/$authView'
      path: '/auth/$authView'
      fullPath: '/auth/$authView'
      preLoaderRoute: typeof AuthAuthViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/subscription': {
      id: '/_app/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AppSubscriptionRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/pricing': {
      id: '/_app/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AppPricingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization': {
      id: '/_app/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppOrganizationRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug': {
      id: '/_app/projects/$projectSlug'
      path: '/projects/$projectSlug'
      fullPath: '/projects/$projectSlug'
      preLoaderRoute: typeof AppProjectsProjectSlugRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/schema-builder/': {
      id: '/_app/schema-builder/'
      path: '/schema-builder'
      fullPath: '/schema-builder'
      preLoaderRoute: typeof AppSchemaBuilderIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization/': {
      id: '/_app/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AppOrganizationIndexRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/stripe/success': {
      id: '/_app/stripe/success'
      path: '/stripe/success'
      fullPath: '/stripe/success'
      preLoaderRoute: typeof AppStripeSuccessRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization/settings': {
      id: '/_app/organization/settings'
      path: '/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof AppOrganizationSettingsRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/members': {
      id: '/_app/organization/members'
      path: '/members'
      fullPath: '/organization/members'
      preLoaderRoute: typeof AppOrganizationMembersRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/billing': {
      id: '/_app/organization/billing'
      path: '/billing'
      fullPath: '/organization/billing'
      preLoaderRoute: typeof AppOrganizationBillingRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/api-keys': {
      id: '/_app/organization/api-keys'
      path: '/api-keys'
      fullPath: '/organization/api-keys'
      preLoaderRoute: typeof AppOrganizationApiKeysRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/cli-project-select/$sessionId': {
      id: '/_app/cli-project-select/$sessionId'
      path: '/cli-project-select/$sessionId'
      fullPath: '/cli-project-select/$sessionId'
      preLoaderRoute: typeof AppCliProjectSelectSessionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account/$accountView': {
      id: '/_app/account/$accountView'
      path: '/account/$accountView'
      fullPath: '/account/$accountView'
      preLoaderRoute: typeof AppAccountAccountViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/cli-auth/$sessionId/': {
      id: '/_app/cli-auth/$sessionId/'
      path: '/cli-auth/$sessionId'
      fullPath: '/cli-auth/$sessionId'
      preLoaderRoute: typeof AppCliAuthSessionIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug/_layout': {
      id: '/_app/projects/$projectSlug/_layout'
      path: '/projects/$projectSlug'
      fullPath: '/projects/$projectSlug'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutRouteRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/templates/': {
      id: '/_app/projects/$projectSlug/templates/'
      path: '/templates'
      fullPath: '/projects/$projectSlug/templates'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesIndexRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/_layout/': {
      id: '/_app/projects/$projectSlug/_layout/'
      path: '/'
      fullPath: '/projects/$projectSlug/'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutIndexRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/settings': {
      id: '/_app/projects/$projectSlug/_layout/settings'
      path: '/settings'
      fullPath: '/projects/$projectSlug/settings'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutSettingsRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/cli-auth/$sessionId/complete/$organizationSlug': {
      id: '/_app/cli-auth/$sessionId/complete/$organizationSlug'
      path: '/cli-auth/$sessionId/complete/$organizationSlug'
      fullPath: '/cli-auth/$sessionId/complete/$organizationSlug'
      preLoaderRoute: typeof AppCliAuthSessionIdCompleteOrganizationSlugRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/'
      path: '/templates/$templateSlug'
      fullPath: '/projects/$projectSlug/templates/$templateSlug'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/logs': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/logs'
      path: '/templates/$templateSlug/logs'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/logs'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/edit': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/edit'
      path: '/templates/$templateSlug/edit'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/edit'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
  }
}

interface AppOrganizationRouteRouteChildren {
  AppOrganizationApiKeysRoute: typeof AppOrganizationApiKeysRoute
  AppOrganizationBillingRoute: typeof AppOrganizationBillingRoute
  AppOrganizationMembersRoute: typeof AppOrganizationMembersRoute
  AppOrganizationSettingsRoute: typeof AppOrganizationSettingsRoute
  AppOrganizationIndexRoute: typeof AppOrganizationIndexRoute
}

const AppOrganizationRouteRouteChildren: AppOrganizationRouteRouteChildren = {
  AppOrganizationApiKeysRoute: AppOrganizationApiKeysRoute,
  AppOrganizationBillingRoute: AppOrganizationBillingRoute,
  AppOrganizationMembersRoute: AppOrganizationMembersRoute,
  AppOrganizationSettingsRoute: AppOrganizationSettingsRoute,
  AppOrganizationIndexRoute: AppOrganizationIndexRoute,
}

const AppOrganizationRouteRouteWithChildren =
  AppOrganizationRouteRoute._addFileChildren(AppOrganizationRouteRouteChildren)

interface AppProjectsProjectSlugLayoutRouteRouteChildren {
  AppProjectsProjectSlugLayoutSettingsRoute: typeof AppProjectsProjectSlugLayoutSettingsRoute
  AppProjectsProjectSlugLayoutIndexRoute: typeof AppProjectsProjectSlugLayoutIndexRoute
}

const AppProjectsProjectSlugLayoutRouteRouteChildren: AppProjectsProjectSlugLayoutRouteRouteChildren =
  {
    AppProjectsProjectSlugLayoutSettingsRoute:
      AppProjectsProjectSlugLayoutSettingsRoute,
    AppProjectsProjectSlugLayoutIndexRoute:
      AppProjectsProjectSlugLayoutIndexRoute,
  }

const AppProjectsProjectSlugLayoutRouteRouteWithChildren =
  AppProjectsProjectSlugLayoutRouteRoute._addFileChildren(
    AppProjectsProjectSlugLayoutRouteRouteChildren,
  )

interface AppProjectsProjectSlugRouteChildren {
  AppProjectsProjectSlugLayoutRouteRoute: typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  AppProjectsProjectSlugTemplatesIndexRoute: typeof AppProjectsProjectSlugTemplatesIndexRoute
  AppProjectsProjectSlugTemplatesTemplateSlugEditRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}

const AppProjectsProjectSlugRouteChildren: AppProjectsProjectSlugRouteChildren =
  {
    AppProjectsProjectSlugLayoutRouteRoute:
      AppProjectsProjectSlugLayoutRouteRouteWithChildren,
    AppProjectsProjectSlugTemplatesIndexRoute:
      AppProjectsProjectSlugTemplatesIndexRoute,
    AppProjectsProjectSlugTemplatesTemplateSlugEditRoute:
      AppProjectsProjectSlugTemplatesTemplateSlugEditRoute,
    AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute:
      AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute,
    AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute:
      AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute,
  }

const AppProjectsProjectSlugRouteWithChildren =
  AppProjectsProjectSlugRoute._addFileChildren(
    AppProjectsProjectSlugRouteChildren,
  )

interface AppRouteRouteChildren {
  AppOrganizationRouteRoute: typeof AppOrganizationRouteRouteWithChildren
  AppPricingRoute: typeof AppPricingRoute
  AppSubscriptionRoute: typeof AppSubscriptionRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountAccountViewRoute: typeof AppAccountAccountViewRoute
  AppCliProjectSelectSessionIdRoute: typeof AppCliProjectSelectSessionIdRoute
  AppStripeSuccessRoute: typeof AppStripeSuccessRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppSchemaBuilderIndexRoute: typeof AppSchemaBuilderIndexRoute
  AppProjectsProjectSlugRoute: typeof AppProjectsProjectSlugRouteWithChildren
  AppCliAuthSessionIdIndexRoute: typeof AppCliAuthSessionIdIndexRoute
  AppCliAuthSessionIdCompleteOrganizationSlugRoute: typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppOrganizationRouteRoute: AppOrganizationRouteRouteWithChildren,
  AppPricingRoute: AppPricingRoute,
  AppSubscriptionRoute: AppSubscriptionRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountAccountViewRoute: AppAccountAccountViewRoute,
  AppCliProjectSelectSessionIdRoute: AppCliProjectSelectSessionIdRoute,
  AppStripeSuccessRoute: AppStripeSuccessRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppSchemaBuilderIndexRoute: AppSchemaBuilderIndexRoute,
  AppProjectsProjectSlugRoute: AppProjectsProjectSlugRouteWithChildren,
  AppCliAuthSessionIdIndexRoute: AppCliAuthSessionIdIndexRoute,
  AppCliAuthSessionIdCompleteOrganizationSlugRoute:
    AppCliAuthSessionIdCompleteOrganizationSlugRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  DashboardRoute: DashboardRoute,
  GrapesRoute: GrapesRoute,
  GrapesPreviewRoute: GrapesPreviewRoute,
  UmoRoute: UmoRoute,
  AuthAuthViewRoute: AuthAuthViewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
